class ConfirmDialog {
  constructor() {
    Turbo.config.forms.confirm = this.confirmMethod.bind(this);
  }

  confirmMethod(message, element) {
    const dialog = this.insertConfirmModal(message, element);
    dialog.showModal();
    return new Promise((resolve) => {
      dialog.querySelectorAll("[data-behavior='cancel']").forEach((cancelButton) => {
        cancelButton.addEventListener("click", () => {
          dialog.remove();
          resolve(false);
        }, { once: true });
      })

      dialog.querySelector("[data-behavior='commit']").addEventListener("click", () => {
        dialog.remove();
        resolve(true);
      }, { once: true });
    });
  }

  insertConfirmModal(message, element) {
    const content = `
      <dialog class="du-modal" id="confirm-modal">
        <div class="du-modal-box">
          <button type="button" class="du-btn du-btn-sm du-btn-circle du-btn-ghost absolute right-2 top-2" data-behavior="cancel" autofocus>
            <i class="icon-x"></i>
          </button>
          <h2 class="text-xl">${message}</h2>
          <div class="mt-5 flex flex-row-reverse gap-4">
            <button type="button" data-behavior="commit" class="du-btn du-btn-error"> Yes </button>
            <button type="button" data-behavior="cancel" class="du-btn du-btn-link ml-3"> Cancel </button>
          </div>
        </div
      </dialog>
    `;

    document.body.insertAdjacentHTML('beforeend', content);
    document.activeElement.blur();

    return document.getElementById("confirm-modal");
  }
}

export default ConfirmDialog;